import { CombinatorSelectProps } from '../types';
import { CombinatorSelect } from './CombinatorSelect';
import { DQBSearchVariant } from './types';

export const QueryCombinatorSelect = (props: CombinatorSelectProps) => (
  <CombinatorSelect {...props} variant={DQBSearchVariant.Query} />
);

export const RequirementCombinatorSelect = (props: CombinatorSelectProps) => (
  <CombinatorSelect {...props} variant={DQBSearchVariant.Requirement} />
);

export const CriteriaCombinatorSelect = (props: CombinatorSelectProps) => (
  <CombinatorSelect {...props} variant={DQBSearchVariant.Criteria} />
);
